import { render, staticRenderFns } from "./DistributorSettings.vue?vue&type=template&id=04559b8a&scoped=true&"
import script from "./DistributorSettings.vue?vue&type=script&lang=js&"
export * from "./DistributorSettings.vue?vue&type=script&lang=js&"
import style0 from "./DistributorSettings.vue?vue&type=style&index=0&id=04559b8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04559b8a",
  null
  
)

export default component.exports